// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function GlobeBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M16 2.5A13.5 13.5 0 1 0 29.5 16 13.515 13.515 0 0 0 16 2.5Zm-2.616 19h5.232A14.47 14.47 0 0 1 16 26.231a14.467 14.467 0 0 1-2.616-4.731Zm-.708-3a17.819 17.819 0 0 1 0-5h6.648a17.819 17.819 0 0 1 0 5h-6.648ZM5.5 16c0-.842.102-1.682.304-2.5h3.849a20.567 20.567 0 0 0 0 5h-3.85A10.436 10.436 0 0 1 5.5 16Zm13.116-5.5h-5.232A14.467 14.467 0 0 1 16 5.769a14.47 14.47 0 0 1 2.616 4.731Zm3.732 3h3.848a10.44 10.44 0 0 1 0 5h-3.849c.204-1.66.204-3.34 0-5Zm2.592-3h-3.19a18.576 18.576 0 0 0-1.744-4.204c2.045.85 3.77 2.32 4.934 4.204ZM12 6.296a18.575 18.575 0 0 0-1.75 4.204H7.06A10.562 10.562 0 0 1 12 6.296ZM7.06 21.5h3.19c.409 1.468.996 2.88 1.75 4.204A10.563 10.563 0 0 1 7.06 21.5Zm12.946 4.204A18.577 18.577 0 0 0 21.75 21.5h3.19a10.563 10.563 0 0 1-4.934 4.204Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
